/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const ClientEvent = ({size, ...props}) => (
  <svg viewBox="0 0 12 11" fill="currentColor" width={ size || "12" } height={ size || "11" } {...props}>
    <g fill="#444856" fillRule="evenodd">
      <path d="M1.5 0h9c.828 0 1.5.448 1.5 1v9c0 .552-.672 1-1.5 1h-9C.672 11 0 10.552 0 10V1c0-.552.672-1 1.5-1zM1 1v9h10.064V1H1z" />
      <path d="M4.267 8c.344 0 .668-.078.972-.234.304-.156.558-.375.761-.656l-.658-.743c-.125.2-.279.358-.463.472-.184.113-.38.17-.587.17-.24 0-.45-.063-.63-.19-.18-.128-.321-.305-.423-.533-.101-.227-.152-.49-.152-.79 0-.298.05-.56.152-.786.102-.225.243-.401.426-.529.182-.127.39-.19.627-.19.207 0 .403.057.587.17.184.114.338.271.463.472L6 3.89c-.203-.285-.452-.505-.748-.66-.297-.153-.616-.23-.96-.23-.447 0-.844.106-1.19.318-.345.212-.615.505-.81.88C2.097 4.573 2 5.006 2 5.497c0 .49.096.924.289 1.302.192.377.46.671.801.883.342.212.734.318 1.177.318zM10 8v-.986H8.012V5.979H9.89v-.986H8.012V3.986H10V3H7v5h3z"
        fillRule="nonzero" />
    </g>
  </svg>
);
ClientEvent.displayName = 'ClientEvent';
ClientEvent.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
